import React from 'react';
import { cn } from '../../utils/cn';

const Button = ({ children, onClick, className, variant = 'default', ...props }) => {
	const buttonBaseClasses =
		'group relative inline-flex w-full items-center justify-center rounded-xl py-3 px-6 font-medium transition-all duration-300 overflow-hidden';

	const backgroundClasses = {
		default: 'bg-gradient-to-r from-orange to-purple',
		'outline-gradient-text': 'bg-white border border-orange hover:bg-gradient-to-r hover:from-orange hover:to-purple hover:border-transparent'
	};

	const fillSpanClasses = {
		default:
			'pointer-events-none absolute inset-[1px] rounded-[inherit] bg-transparent transition-colors duration-300 group-hover:bg-white',
		'outline-gradient-text': 'hidden'
	};

	const textSpanClasses = {
		default:
			'relative z-10 bg-gradient-to-r from-orange to-purple bg-clip-text text-white transition-colors duration-300 group-hover:text-transparent',
		'outline-gradient-text':
			'relative z-10 bg-gradient-to-r from-orange to-purple bg-clip-text text-transparent transition-colors duration-300 group-hover:text-white'
	};

	const disabledClasses = props.disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : '';

	return (
		<button
			onClick={onClick}
			{...props}
			className={cn(buttonBaseClasses, backgroundClasses[variant], disabledClasses, className)}
		>
			{/* White fill on hover, leaving a gradient border (1px) */}
			<span className={cn(fillSpanClasses[variant])} />
			{/* Text turns gradient on hover */}
			<span className={cn(textSpanClasses[variant])}>{children}</span>
		</button>
	);
};
export default Button;
